export default class DtoPublicPicture {
    constructor(obj) {
        this.url = obj.url
        this.name = obj.name
        this.size = obj.size
        this.updateDate = obj.updateDate
        this.stationType = obj.stationType
    }
}